/* Product presentation only. The existing cart drawer/app integration owns cart requests. */
(function () {
  'use strict';
  if (window.__abundanceProductLoaded) return;
  window.__abundanceProductLoaded = true;
  var instances = new WeakMap();
  function repairReviewLink(link) {
    var href = link.getAttribute('href') || '';
    if (href.charAt(0) !== '#') return;
    var id;
    try { id = decodeURIComponent(href.slice(1)); } catch (error) { return; }
    if (document.getElementById(id)) return;
    // Only migrate our old Loox section IDs; custom review URLs/anchors keep their behavior.
    var legacy = id.match(/^zlx-(?:template--[^_]+__)?(loox(?:_[A-Za-z0-9_-]+)?)$/);
    if (!legacy) return;
    var target = document.getElementById('abundance-reviews-' + legacy[1]);
    if (target && target.matches('[data-ab-review-target]')) link.setAttribute('href', '#' + target.id);
  }
  function initialize(root) {
    if (instances.has(root)) return;
    var controller = new AbortController(), signal = controller.signal;
    root.querySelectorAll('[data-ab-review-link]').forEach(repairReviewLink);
    root.addEventListener('click', function (event) {
      var link = event.target.closest('[data-ab-review-link]');
      if (link && root.contains(link)) repairReviewLink(link);
    }, { signal: signal });
    var viewport = root.querySelector('[data-ab-gallery]');
    var slides = Array.from(root.querySelectorAll('[data-ab-slide]'));
    var thumbs = Array.from(root.querySelectorAll('[data-ab-thumb]'));
    var previous = root.querySelector('[data-ab-prev]'), next = root.querySelector('[data-ab-next]');
    var counter = root.querySelector('[data-ab-index]');
    var form = root.querySelector('.ab-product__form');
    var variantInput = root.querySelector('[data-ab-variant]');
    var quantityInput = root.querySelector('[data-ab-quantity]');
    var primaryButton = root.querySelector('[data-ab-primary-atc]');
    var buttons = Array.from(root.querySelectorAll('[data-ab-atc]'));
    var sticky = root.querySelector('[data-ab-sticky]');
    var variants = [], moneyFormat = '';
    try { variants = JSON.parse(root.querySelector('[data-ab-variants]').textContent); } catch (error) { /* Native form remains usable. */ }
    try { moneyFormat = JSON.parse(root.querySelector('[data-ab-money-format]').textContent); } catch (error) { /* Intl fallback below. */ }
    var activeIndex = 0, galleryFrame = 0, stickyFrame = 0, countdownTimer = 0, gallerySynced = false;
    var resizeObserver = null, busyObserver = null, stickyObserver = null;
    var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mobile = window.matchMedia('(max-width: 749px)');
    function selectedVariant() {
      return variants.find(function (variant) { return String(variant.id) === String(variantInput && variantInput.value); });
    }
    function formatMoney(cents) {
      var match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
      if (match) {
        var token = match[1], decimals = token.indexOf('no_decimals') === -1 ? 2 : 0;
        var decimal = token.indexOf('comma_separator') !== -1 ? ',' : '.';
        var thousand = decimal === ',' ? '.' : ',';
        if (token.indexOf('space_separator') !== -1) { thousand = ' '; if (token.indexOf('period_and_space') === -1) decimal = ','; }
        if (token.indexOf('apostrophe_separator') !== -1) thousand = "'";
        var parts = (cents / 100).toFixed(decimals).split('.');
        var value = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousand) + (decimals ? decimal + parts[1] : '');
        var clean = document.createElement('span');
        clean.innerHTML = moneyFormat.replace(match[0], value);
        return clean.textContent;
      }
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: root.dataset.currency || 'USD' }).format(cents / 100); }
      catch (error) { return (cents / 100).toFixed(2); }
    }
    function loadSlide(index, priority) {
      var slide = slides[index];
      if (!slide) return;
      var template = slide.querySelector('[data-ab-slide-image]');
      if (template) {
        var content = template.content.cloneNode(true);
        var image = content.querySelector('img');
        if (image) {
          image.loading = 'eager';
          image.setAttribute('fetchpriority', priority || 'low');
        }
        template.replaceWith(content);
      } else if (priority === 'high') {
        var currentImage = slide.querySelector('img');
        if (currentImage) currentImage.setAttribute('fetchpriority', 'high');
      }
    }
    function prepareSwipe() {
      loadSlide(activeIndex - 1);
      loadSlide(activeIndex + 1);
    }
    function syncGallery(index) {
      var nextIndex = Math.max(0, Math.min(slides.length - 1, index));
      // Scroll fires every frame during a swipe: skip same-slide rewrites (no redundant DOM mutations).
      if (gallerySynced && nextIndex === activeIndex) return;
      gallerySynced = true;
      activeIndex = nextIndex;
      loadSlide(activeIndex, 'high');
      thumbs.forEach(function (thumb, i) { thumb.setAttribute('aria-current', String(i === activeIndex)); });
      if (counter) counter.textContent = String(activeIndex + 1);
      if (previous) previous.disabled = activeIndex <= 0;
      if (next) next.disabled = activeIndex >= slides.length - 1;
    }
    function goTo(index, instant) {
      if (!viewport || !slides.length) return;
      syncGallery(index);
      viewport.scrollTo({ left: activeIndex * viewport.clientWidth, behavior: instant || motion.matches ? 'instant' : 'smooth' });
    }
    if (viewport) {
      viewport.addEventListener('pointerdown', prepareSwipe, { passive: true, signal: signal });
      viewport.addEventListener('wheel', function (event) { if (event.deltaX) prepareSwipe(); }, { passive: true, signal: signal });
      viewport.addEventListener('scroll', function () {
        if (galleryFrame) return;
        galleryFrame = window.requestAnimationFrame(function () {
          galleryFrame = 0;
          if (viewport.clientWidth) syncGallery(Math.round(viewport.scrollLeft / viewport.clientWidth));
        });
      }, { passive: true, signal: signal });
      viewport.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); goTo(activeIndex + (event.key === 'ArrowRight' ? 1 : -1)); }
        if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); goTo(event.key === 'Home' ? 0 : slides.length - 1); }
      }, { signal: signal });
      if ('ResizeObserver' in window) {
        var oldWidth = viewport.clientWidth;
        resizeObserver = new ResizeObserver(function () {
          if (viewport.clientWidth !== oldWidth) { oldWidth = viewport.clientWidth; goTo(activeIndex, true); }
        });
        resizeObserver.observe(viewport);
      }
    }
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('pointerenter', function () { loadSlide(i); }, { passive: true, signal: signal });
      thumb.addEventListener('focus', function () { loadSlide(i); }, { signal: signal });
      thumb.addEventListener('click', function () { goTo(i); }, { signal: signal });
    });
    if (previous) previous.addEventListener('click', function () { goTo(activeIndex - 1); }, { signal: signal });
    if (next) next.addEventListener('click', function () { goTo(activeIndex + 1); }, { signal: signal });
    syncGallery(0);
    function quantityLimits(variant) {
      var min = Math.max(1, Number(variant.min) || 1), step = Math.max(1, Number(variant.step) || 1), max = variant.max == null ? Infinity : Number(variant.max);
      if (variant.stock != null) max = Math.min(max, Math.max(0, Number(variant.stock)));
      return { min: min, step: step, max: max };
    }
    function updatePurchase(normalize) {
      var variant = selectedVariant();
      if (!variant) return;
      var limits = quantityLimits(variant), quantity = quantityInput ? Number(quantityInput.value) : limits.min;
      if (quantityInput) {
        quantityInput.min = String(limits.min);
        quantityInput.step = String(limits.step);
        if (Number.isFinite(limits.max)) quantityInput.max = String(limits.max);
        else quantityInput.removeAttribute('max');
        if (normalize || quantityInput.type === 'hidden') {
          if (!Number.isFinite(quantity) || quantity < limits.min) quantity = limits.min;
          quantity = limits.min + Math.floor((quantity - limits.min) / limits.step) * limits.step;
          if (quantity > limits.max && limits.max >= limits.min) quantity = limits.min + Math.floor((limits.max - limits.min) / limits.step) * limits.step;
          quantityInput.value = String(quantity);
        }
      }
      var validQuantity = quantity >= limits.min && quantity <= limits.max && Number.isInteger((quantity - limits.min) / limits.step);
      var available = Boolean(variant.available) && limits.max >= limits.min;
      var busy = Boolean(form && form.getAttribute('aria-busy') === 'true');
      var hasCompare = Number(variant.compare) > Number(variant.price);
      var safeQuantity = Number.isFinite(quantity) && quantity > 0 ? quantity : limits.min;
      var priceText = safeQuantity === 1 ? variant.priceFormatted : formatMoney(variant.price * safeQuantity);
      var compareText = safeQuantity === 1 ? variant.compareFormatted : formatMoney(variant.compare * safeQuantity);
      root.querySelectorAll('[data-ab-unit-price]').forEach(function (node) { node.textContent = variant.priceFormatted; });
      root.querySelectorAll('[data-ab-unit-compare]').forEach(function (node) { node.textContent = variant.compareFormatted; node.hidden = !hasCompare; });
      buttons.forEach(function (button) {
        button.disabled = !available || !validQuantity || busy;
        var label = button.querySelector('[data-ab-atc-label]');
        if (label && !busy) label.textContent = available ? button.dataset.abLabel : (button.dataset.abSoldOut || 'Sold out');
        var money = button.querySelector('[data-ab-atc-money]');
        var price = button.querySelector('[data-ab-atc-price]');
        var compare = button.querySelector('[data-ab-atc-compare]');
        if (money) money.hidden = !available;
        if (price) price.textContent = priceText;
        if (compare) { compare.textContent = compareText; compare.hidden = !hasCompare; }
      });
      root.querySelectorAll('[data-ab-quantity-step]').forEach(function (button) {
        button.disabled = !available || (Number(button.dataset.abQuantityStep) < 0 ? quantity <= limits.min : quantity + limits.step > limits.max);
      });
      root.querySelectorAll('[data-ab-stock]').forEach(function (node) {
        node.hidden = variant.stock == null;
        if (variant.stock != null) node.textContent = node.closest('[data-ab-availability]').dataset.stockLabel.replace('[count]', String(variant.stock));
      });
    }
    root.addEventListener('change', function (event) {
        if (event.target === variantInput) {
          updatePurchase(true);
          if (!(window.Shopify && window.Shopify.designMode)) {
            try { var url = new URL(window.location.href); url.searchParams.set('variant', variantInput.value); window.history.replaceState({}, '', url.toString()); } catch (error) { /* Native form remains the source of truth. */ }
          }
        } else if (event.target === quantityInput) updatePurchase(true);
    }, { signal: signal });
    root.addEventListener('input', function (event) { if (event.target === quantityInput) updatePurchase(false); }, { signal: signal });
    if (form) {
      busyObserver = new MutationObserver(function () { updatePurchase(false); });
      busyObserver.observe(form, { attributes: true, attributeFilter: ['aria-busy'] });
    }
    root.querySelectorAll('[data-ab-quantity-step]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!quantityInput) return;
        var variant = selectedVariant();
        if (!variant) return;
        var limits = quantityLimits(variant);
        quantityInput.value = String(Math.max(limits.min, Math.min(limits.max, (Number(quantityInput.value) || limits.min) + Number(button.dataset.abQuantityStep) * limits.step)));
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }, { signal: signal });
    });
    updatePurchase(true);
    function updateSticky() {
      stickyFrame = 0;
      if (!sticky) return;
      sticky.hidden = !primaryButton || !mobile.matches || !primaryButton.getClientRects().length || primaryButton.getBoundingClientRect().bottom > 0;
    }
    function queueSticky() { if (!stickyFrame) stickyFrame = window.requestAnimationFrame(updateSticky); }
    if (sticky && primaryButton) {
      window.addEventListener('resize', queueSticky, { passive: true, signal: signal });
      if ('IntersectionObserver' in window) { stickyObserver = new IntersectionObserver(updateSticky); stickyObserver.observe(primaryButton); }
      else window.addEventListener('scroll', queueSticky, { passive: true, signal: signal });
      updateSticky();
    }
    var deadlines = Array.from(root.querySelectorAll('[data-ab-deadline]')).map(function (box) {
      var value = box.dataset.abDeadline;
      var end = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(value) ? Date.parse(value) : NaN;
      if (!Number.isFinite(end)) { box.hidden = true; return null; }
      return { box: box, end: end, output: box.querySelector('[data-ab-countdown]'), label: box.querySelector('[data-ab-deadline-label]') };
    }).filter(Boolean);
    function tick() {
      var active = false;
      deadlines.forEach(function (entry) {
        var left = Math.max(0, Math.floor((entry.end - Date.now()) / 1000));
        if (!left) {
          if (entry.label) entry.label.textContent = entry.box.dataset.endedLabel;
          if (entry.output) entry.output.hidden = true;
          return;
        }
        active = true;
        var days = Math.floor(left / 86400), hours = Math.floor(left % 86400 / 3600), minutes = Math.floor(left % 3600 / 60), seconds = left % 60;
        if (entry.output) entry.output.textContent = (days ? days + 'd ' : '') + [hours, minutes, seconds].map(function (value) { return String(value).padStart(2, '0'); }).join(':');
      });
      if (!active && countdownTimer) { window.clearInterval(countdownTimer); countdownTimer = 0; }
    }
    if (deadlines.length) { countdownTimer = window.setInterval(tick, 1000); tick(); }
    instances.set(root, {
      goTo: goTo,
      destroy: function () {
        controller.abort();
        if (galleryFrame) window.cancelAnimationFrame(galleryFrame);
        if (stickyFrame) window.cancelAnimationFrame(stickyFrame);
        if (countdownTimer) window.clearInterval(countdownTimer);
        if (resizeObserver) resizeObserver.disconnect();
        if (busyObserver) busyObserver.disconnect();
        if (stickyObserver) stickyObserver.disconnect();
        instances.delete(root);
      }
    });
  }
  function roots(scope) {
    var result = Array.from(scope.querySelectorAll('[data-ab-product]'));
    if (scope.matches && scope.matches('[data-ab-product]')) result.unshift(scope);
    return result;
  }
  function mount(scope) { roots(scope).forEach(initialize); }
  document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { roots(event.target).forEach(function (root) { var instance = instances.get(root); if (instance) instance.destroy(); }); });
  document.addEventListener('shopify:block:select', function (event) {
    var block = event.target.closest('[data-ab-slide],[data-ab-block]');
    if (!block && event.detail && event.detail.blockId) block = Array.from(event.target.querySelectorAll('[data-ab-slide],[data-ab-block]')).find(function (item) { return item.dataset.blockId === event.detail.blockId || item.dataset.abBlock === event.detail.blockId; });
    if (!block) return;
    var root = block.closest('[data-ab-product]'), instance = root && instances.get(root);
    if (instance && block.matches('[data-ab-slide]')) instance.goTo(Array.from(root.querySelectorAll('[data-ab-slide]')).indexOf(block), true);
    var detail = block.querySelector('details');
    if (detail) detail.open = true;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mount(document); }, { once: true });
  else mount(document);
})();
